import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { CrawlRunStatus } from '../../../types/WebsiteSource';

dayjs.extend(relativeTime);

export const formatDateTime = (value: string | null | undefined): string =>
  value ? dayjs(value).format('D MMM YYYY HH:mm') : '';

/** "in 6 hours" / "2 days ago"; the absolute time goes in a tooltip. */
export const formatRelative = (value: string | null | undefined): string =>
  value ? dayjs(value).fromNow() : '';

export const formatInterval = (hours: number): string => {
  if (hours === 24) return 'Daily';
  if (hours === 168) return 'Weekly';
  if (hours === 720) return 'Monthly';
  if (hours % 24 === 0) return `Every ${hours / 24} days`;
  return `Every ${hours} hours`;
};

export const runStatusVariant = (
  status: CrawlRunStatus | null
): 'default' | 'secondary' | 'destructive' | 'outline' => {
  switch (status) {
    case 'SUCCEEDED':
      return 'default';
    case 'FAILED':
      return 'destructive';
    case 'RUNNING':
    case 'PENDING':
      return 'secondary';
    default:
      return 'outline';
  }
};
